import { gql } from 'types/__generated__/gql';

const KEY_AVERAGE_WEEKLY_TIME_SPENT_ASYNC_QUERY = gql(/* GraphQL */ `
  query getAverageWeeklyTimeSpentReportAsync(
    $where: KeyReportWhereInput!
    $dateRange: DateRangeInput!
  ) {
    keyAverageWeeklyTimeSpentReportAsync(where: $where, dateRange: $dateRange) {
      id
      error
      result {
        curriculumAverageWeeklyTimeSpent {
          productCurriculumCode
          averageWeeklyMinutesSpent
        }
        averageWeeklyMinutesSpent
      }
    }
  }
`);

export default KEY_AVERAGE_WEEKLY_TIME_SPENT_ASYNC_QUERY;
